var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-config',{attrs:{"values":_vm.getCounterparties,"displayText":"name","onSaveHandler":_vm.onSave,"onDeleteHandler":_vm.onDelete,"entityName":"Counterparty"},scopedSlots:_vm._u([{key:"entryForm",fn:function(ref){
var selectedItem = ref.selectedItem;
var onSaveItem = ref.onSaveItem;
var onDeleteItem = ref.onDeleteItem;
return [_c('EntryForm',{attrs:{"model":_vm.dataModel,"data":selectedItem,"mode":selectedItem ? 'viewEdit' : 'new'},on:{"onSave":onSaveItem,"onDelete":onDeleteItem}})]}},{key:"itemListing",fn:function(ref){
var onItemSelected = ref.onItemSelected;
var values = ref.values;
var displayText = ref.displayText;
return [_c('item-list',{attrs:{"title":"","items":values,"text":displayText,"clickable":true},on:{"onClick":onItemSelected}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }